import { Color, palette, setColor } from 'app_previous/styles/colors';
import { layout } from 'app_previous/styles/layout';
import styled from 'styled-components';

interface ResourceCenterMenuContainerProps {
  backgroundColor: Color;
}

export const ResourceCenterMenuContainer = styled.div<ResourceCenterMenuContainerProps>`
  max-width: 100vw !important;
  display: grid;
  position: relative;
  z-index: 10;
  background: ${({ backgroundColor }) => setColor(backgroundColor)};
`;

export const ResourceCenterMenuLinksMobile = styled.div`
  display: none;
  height: 64px;
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  justify-content: space-around;
  color: ${palette.white};

  @media all and (max-width: ${layout.lg}) {
    display: grid;
  }
`;

export const ResourceCenterMenuLinks = styled.div`
  display: flex;
  min-height: 64px; // Text overflows in two lines, don't force height
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  justify-content: space-around;
  color: ${palette.white};

  @media all and (max-width: ${layout.lg}) {
    display: none;
  }
`;

interface ResourceCenterMenuLinkGroupProps {
  hoverColor: Color;
}

export const ResourceCenterMenuLinkGroup = styled.div<ResourceCenterMenuLinkGroupProps>`
  position: relative;
  display: grid;
  z-index: 10;

  a {
    color: ${palette.white};
    text-decoration: none;
    align-self: center;
    justify-self: center;
    padding: 1.4rem 0.5rem;
    font-size: 1rem;
    text-align: center;
  }

  &:hover {
    color: ${palette.text};
    background: ${({ hoverColor }) => setColor(hoverColor)};

    a {
      color: ${palette.white};
    }
    & > div {
      display: block;
    }
  }

  @media all and (max-width: ${layout.lg}) {
    position: absolute;
    width: 100%;
    text-align: center;

    a {
      width: 100%;
    }
  }
`;

interface ResourceCenterOrientationProps {
  horizontalOrientation?: 'left' | 'right';
  verticalOrientation?: 'top' | 'bottom';
}

interface ResourceCenterMenuLinkSubGroupProps extends ResourceCenterOrientationProps {
  backgroundColor: Color;
}

export const ResourceCenterMenuLinkSubGroup = styled.div<ResourceCenterMenuLinkSubGroupProps>`
  ${({ horizontalOrientation }) => (horizontalOrientation === 'left' ? 'right: 0px' : 'left: 0px')};
  ${({ verticalOrientation }) => (verticalOrientation == 'top' ? 'bottom: 100%' : 'top: 100%')};
  display: none;
  position: absolute;
  width: max-content;
  max-width: 350px;
  background: ${({ backgroundColor }) => setColor(backgroundColor)};

  a {
    color: ${palette.text};
    text-decoration: none;
    align-self: center;
    justify-content: space-between;
    padding: 1.375rem 1.25rem;
    display: flex;
  }
`;

export const ChevronWhiteContainer = styled.div<Pick<ResourceCenterOrientationProps, 'horizontalOrientation'>>`
  margin-top: 2px;
  transition: transform 0.3s;
  ${({ horizontalOrientation }) => (horizontalOrientation === 'right' ? 'margin-left: 20px' : 'margin-right: 20px;')}
`;

export const ResourceCenterMenuLinkSubEntry = styled.div<Pick<ResourceCenterOrientationProps, 'horizontalOrientation'>>`
  position: relative;

  & > a {
    flex-direction: ${({ horizontalOrientation }) => (horizontalOrientation === 'right' ? 'row-reverse;' : 'row;')};
  }

  &:hover {
    & > a {
      text-decoration: underline;

      & > div.arrow-right {
        transform: translateX(5px);
      }

      & > div.arrow-left {
        transform: translateX(-5px);
      }
    }

    & > div {
      display: block;
    }
  }
`;

interface ResourceCenterMenuLinkPostProps extends ResourceCenterOrientationProps {
  backgroundColor: Color;
}

export const ResourceCenterMenuLinkPost = styled.div<ResourceCenterMenuLinkPostProps>`
  ${({ verticalOrientation }) => (verticalOrientation == 'top' ? 'bottom: 0' : 'top: 0')};
  ${({ horizontalOrientation }) => (horizontalOrientation === 'left' ? 'right: 100%' : 'left: 100%')};
  position: absolute;
  display: none;
  width: max-content;
  max-width: 350px;
  background: ${({ backgroundColor }) => setColor(backgroundColor)};

  a {
    color: ${palette.text};
    text-decoration: none;
    align-self: center;
    justify-self: ${({ horizontalOrientation }) => (horizontalOrientation === 'left' ? 'end' : 'start')};
    padding: 1.375rem 0.5rem 1.375rem 1rem;

    &:before,
    &:after {
      display: none;
    }
  }
`;
